import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, tap } from 'rxjs';
import { MessageService } from './message.service';
import { ApiService } from './api.service';
import { LocationService } from './location.service';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { AuthInterceptor } from '../interceptors/auth.interceptor';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  employeeId!: number

  constructor(private httpClient: HttpClient,
    private locationService: LocationService,
    private messageService: MessageService,
    private apiService: ApiService,
    public router: Router) { }

  getToken() {
    return localStorage.getItem('customer_access_token');
  }

  isGuest() {
    return !!localStorage.getItem('customer_access_token')
  }

  organizationByGeoIP(): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/organization/geoip`)
  }

  organizationByCountryCode(code: string): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/organization/country-code`, { params: new HttpParams({ fromObject: { code: code } }) })
  }

  organizationById(code: string): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/organization/id`, { params: new HttpParams({ fromObject: { id: code } }) })
  }

  public existingUser(email: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/existing-user`, {
      email: email,
      organization: this.apiService.organizationId()
    });
  }

  signin(params: any) {
    return this.httpClient.post<any>(`${this.apiService.apiUrl()}/api/customer/signin`, {
      email: params.email,
      password: params.password,
      organization: this.apiService.organizationId()
    }).pipe(
      tap({
        next: (res: any) => {
          AuthInterceptor.resetRequired()

          localStorage.setItem('customer_access_token', res.token.token);

          
          this.messageService.connect()
          this.locationService.updateLogin()

          if (Capacitor.getPlatform() != 'web') {
            if (localStorage.getItem('api_url')) {
              PushNotifications.requestPermissions().then(result => {
                if (result.receive === 'granted') {
                  PushNotifications.register();
                }
              });
            }
          }

          this.loginNavigate()
        },
        error: (error: any) => {
          console.log('signin error', error)
          //alert(error.error)
        }
      })
    )
  }

  signinApple(data: object) {
    return this.httpClient.post<any>(`${this.apiService.apiUrl()}/api/customer/signin-apple`, {
      ...data,
      organization: this.apiService.organizationId()
    }).subscribe({
      next: (res: any) => {
        AuthInterceptor.resetRequired()

        localStorage.setItem('customer_access_token', res.token.token)

        this.messageService.init()
        this.messageService.connect()
        this.locationService.updateLogin()

        if (Capacitor.getPlatform() != 'web') {
          if (localStorage.getItem('api_url')) {
            PushNotifications.requestPermissions().then(result => {
              if (result.receive === 'granted') {
                PushNotifications.register();
              }
            });
          }
        }

        this.loginNavigate()
      },
      error: (error: any) => {
        console.log('apple signin error', error)
        //alert(error.error.message)
      }
    })
  }

  signinGoogle(data: any) {
    return this.httpClient.post<any>(`${this.apiService.apiUrl()}/api/customer/signin-google`, {
      ...data,
      organization: this.apiService.organizationId()
    }).subscribe({
      next: (res: any) => {
        AuthInterceptor.resetRequired()

        localStorage.setItem('customer_access_token', res.token.token);

        this.messageService.init()
        this.messageService.connect()
        this.locationService.updateLogin()

        if (Capacitor.getPlatform() != 'web') {
          if (localStorage.getItem('api_url')) {
            PushNotifications.requestPermissions().then(result => {
              if (result.receive === 'granted') {
                PushNotifications.register();
              }
            });
          }
        }

        this.loginNavigate()
      },
      error: (error: any) => {
        console.log('google signin error', error)
        //alert(error.error.message)
      }
    })
  }

  public loginNavigate() {
    if (localStorage.getItem('order')) {
      const order = JSON.parse(localStorage.getItem('order')!)

      if (order.assignment_id && order.employee_id && order.products && order.products.length > 0 && order.date && order.start_times) {
        this.router.navigate(['/checkout']);
      }
      else if (order.assignment_id && order.products && order.products.length > 0) {
        this.router.navigate(['/schedule']);
      }
      else {
        this.router.navigate(['/']);
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  public signout(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/signout`)
      .pipe(
        tap(() => {
          AuthInterceptor.resetRequired()

          localStorage.removeItem('customer_access_token');
          localStorage.removeItem('order');

          this.messageService.disconnect();
          this.locationService.updateLogin();
        })
      );
  }

  isSignedIn(): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/customer/signed-in`);
  }

  public forgotPassword(email: string | null): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/forgot-password`, { email: email, organization: this.apiService.organizationId() });
  }
}
